const projects = [
    {
        id: 1,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Stanclarej",
        info: "Movie website",
        text: "Technology used",
        technology: "HTML, CSS, JavaScript, webpack, kanban",
        img: './image/STANCLARJ.png',
        lin: '',



    },
    {
        id: 2,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Bpe",
        info: "Company Website",
        text: "Technology used",
        technology: "HTML, CSS, JavaScript, webpack, kanban, JQuery, bootstrap",
        img: './image/bpe-image.png',
        lin: 'https://blessing-michael.github.io/bp-real/index.html',



    },
     {
        id: 2,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Steven and Gerald Holdings",
        info: "Companies Information website",
        text: "Technology used",
        technology: "HTML, CSS, JavaScript",
        img: './image/steven1.png',
        lin: 'https://stevenandgeraldholdings.com/',



    },
     {
        id: 2,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Treendee",
        info: "ecommerce website",
        text: "Technology used",
        technology: "Node.js,Express, MongoDB,Integrated Cloudinary for media storage and Nginx on a Linux VPS.",
        img: './image/treendee2.png',
        lin: 'https://treenddee.com/',



    },
     {
        id: 2,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Babantan",
        info: "information/registration website",
        text: "Technology used",
        technology: "Node.js,Express, MongoDB,Nginx on a Linux VPS.",
        img: './image/babatan1.png',
        lin: 'https://babantan.com/',



    },
     {
        id: 2,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Bros for Lows",
        info: "Humanitarian website",
        text: "Technology used",
        technology: "HTML, CSS, JavaScript",
        img: './image/brosforlows1.png',
        lin: 'https://brosbeforelows.vercel.app/',



    },
     {
        id: 2,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Venek Consult",
        info: "Travel website",
        text: "Technology used",
        technology: "HTML, CSS, JavaScript",
        img: './image/venek1.png',
        lin: 'https://venek-consult.vercel.app/',



    },
    {
        id: 2,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "BleFi Movies",
        info: "Movie website",
        text: "Technology used",
        technology: "HTML, CSS, JavaScript, webpack, kanban",
        img: './image/blefi-img.png',
        lin: '',



    },
    {
        id: 2,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "TicketEase",
        info: "Ticket website",
        text: "Technology used",
        technology: "React.js",
        img: './image/ticketease.png',
        lin: 'https://relaxed-liger-f6d711.netlify.app/',



    },
   
    {
        id: 3,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Book-store",
        info: " Book-store webpage",
        text: "Technology used",
        technology: "React.js",
        img: './image/bookstore-2.png',
        lin: 'https://book-store-6v7u.onrender.com/',



    },
    {
        id: 4,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Portfolio",
        info: "Portfolio Template",
        text: "Technology used",
        technology: "HTML, CSS, JavaScript",
        img: './image/portfolio-temp2.png',
        lin: 'https://blessing-michael.github.io/portfolio/',



    },
    {
        id: 4,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Forecast me",
        info: "Weather Forecast site",
        text: "Technology used",
        technology: "React Js",
        img: './image/weather-snapshot.PNG',
        lin: 'https://forecast-me-tbxm.onrender.com/',



    },
    {
        id: 5,
        // img: "../public/image/tastyDelights.PNG.Untracked",
        title: "Tasty Delights",
        info: "E-commerce site",
        text: "Technology used",
        technology: "React Js",
        img: './image/food-img.png',
        lin: 'https://question-display.netlify.app/',



    },
    // {
    //     id: 2,
    //     // img: "../public/image/tastyDelights.PNG.Untracked",
    //     title: "Tasty Delights",
    //     info: "E-commerce site",
    //     text: "Technology used",
    //      technology: "HTML, CSS, React Js",
    //      img: './image/tastyDelights.PNG',


    // },
    // {
    //     id: 3,
    //     // img: "../public/image/tastyDelights.PNG.Untracked",
    //     title: "Tasty Delights",
    //     info: "E-commerce site",
    //     text: "Technology used",
    //      technology: "HTML, CSS, React Js",
    //      img: './image/tastyDelights.PNG',


    // }

]
export default projects